import styled from "styled-components";
import { theme } from "@themes";

export const Content = styled.div`
  width: 600px;
  // height: 400px;
  margin: auto;
  margin-top: 2em;
  margin-bottom: 3em;
  display: grid;
  grid-template-columns: repeat(
    ${(props) => (props.question == "like" ? "2" : props.cant)},
    1fr
  );
  min-height: 278px;
`;
export const ContentTitle = styled.div`
  grid-column: 1 / ${(props) => (props.question == "like" ? "3" : "6")};
  text-align: center;
  margin: 0px auto;
  label:nth-child(1) {
    font-size: 17px;
    font-weight: 800;
    color: ${({ theme }) => theme.neutral.gray[2700]};
  }
  label:nth-child(3) {
    font-size: 14px;
    font-weight: 800;
    color: ${({ theme }) => theme.neutral.gray[2100]};
  }
`;
export const ContentChoice = styled.div`
  display: grid;
  grid-template-rows: ${(props) =>
    props.question == "like" ? " 11em 1fr" : "3em 7em 3em"};
  margin: 0px auto;
  text-align: center;
  span:nth-child(1) {
    font-size: ${(props) => (props.question == "like" ? "20px" : "15px")};
    color: ${({ theme }) => theme.status.success};
  }
  span:nth-child(2) {
    margin-top: 0.7em;
    font-size: ${(props) => (props.question == "like" ? "17px" : "15px")};
    color: ${({ theme }) => theme.status.success};
  }
  span:nth-child(3) {
    margin-top: 0.7em;
    font-size: ${(props) => (props.question == "like" ? "20px" : "15px")};
    color: ${({ theme }) => theme.status.success};
  }
  svg {
    cursor: pointer;
    -webkit-transition: 0.5s, font-size 0.5s;
    -moz-transition: 0.5s, font-size 0.5s;
    -o-transition: 0.5s, font-size 0.5s;
    transition: 0.5s, font-size 0.5s;
  }
  svg:hover {
    // color: ${({ theme }) => theme.text.primary} !important;
    font-size: ${(props) =>
      props.question == "like" ? "10.5em" : "7.5em"} !important;
  }
`;
export const ContentImage = styled.div`
  // width: 77vw;
  // height: 400px;
  margin: auto;
  margin-top: 2em;
  display: grid;
  grid-template-columns: repeat(${(props) => props.cant}, 15em);
  min-height: 278px;
`;
export const ContentTitleImage = styled.div`
  grid-column: 1/-1;
  text-align: center;
  margin: 0px auto;
  label:nth-child(1) {
    font-size: 17px;
    font-weight: 800;
    color: ${({ theme }) => theme.neutral.gray[2700]};
  }
  label:nth-child(3) {
    font-size: 14px;
    font-weight: 800;
    color: ${({ theme }) => theme.neutral.gray[2100]};
  }
`;
export const ContentChoiceImage = styled.div`
  display: grid;
  grid-template-rows: 2em 9em 2em;
  text-align: center;
  margin: auto;
  span {
    font-size: "20px";
    color: ${({ theme }) => theme.status.success};
  }
  img {
    width: 14em;
    height: 8em;
    cursor: pinter;
    border-radius: 15px;
    -webkit-transition: 0.5s, font-size 0.5s;
    -moz-transition: 0.5s, font-size 0.5s;
    -o-transition: 0.5s, font-size 0.5s;
    transition: 0.5s, font-size 0.5s;
  }
  img:hover {
    width: 14.4em;
    height: 8.4em;
  }
`;

export const ContentOpenText = styled.div`
  width: 600px;
  margin: auto;
  margin-top: 2em;
  display: grid;
  grid-template-columns: 1fr;
  min-height: 168px;
`;
export const ButtonDownLoad = styled.button`
  margin: 1rem !important;
  background: ${({ theme }) => theme.primary.purple};
  color: ${({ theme }) => theme.neutral.white};
  font-size: 14px;
  font-weight: 500;
  border: none;
  box-shadow: 0px 4px 18px ${({ theme }) => theme.shadows.medium};
  border-radius: 5px;
  width: 11em;
  height: 43.21px;
  &:hover {
    box-shadow: 0px 4px 20px 0px ${({ theme }) => theme.primary.purpleLightOpacity};
    transform: translateY(-1px);
    cursor: pointer;
  }
`;
export const ContentOpenTextTitle = styled.div`
  text-align: center;
  margin: 0px auto;
  label:nth-child(1) {
    font-size: 17px;
    font-weight: 800;
    color: ${({ theme }) => theme.neutral.gray[2700]};
  }
  label:nth-child(3) {
    font-size: 14px;
    font-weight: 800;
    color: ${({ theme }) => theme.neutral.gray[2100]};
  }
`;
